import axios from "axios";

export const endpoint = process.env.REACT_APP_API_END_POINT;

export const api = axios.create({
  baseURL: endpoint,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

// SWR fetcher — 표준 응답 { success, alert, data } 를 unwrap.
// success === false 도 throw 없이 통과시켜 페이지가 직접 처리하도록 한다.
export const fetcher = (url) =>
  api.get(url).then((res) => {
    if (res?.data?.success === false) {
      // 권한이 없는 GET 호출은 {success:false, alert} 로 옴
      const e = new Error(res.data?.alert || "요청을 처리할 수 없습니다.");
      e.serverPayload = res.data;
      throw e;
    }
    return res.data?.data ?? res.data;
  });
